namespace Matrix.Data {
    export interface SecurityTypeRow {
        SecurityTypeCode?: string;
        Name?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        DefaultSortOrder?: number;
    }

    export namespace SecurityTypeRow {
        export const idProperty = 'SecurityTypeCode';
        export const nameProperty = 'SecurityTypeCode';
        export const localTextPrefix = 'Data.SecurityType';
        export const lookupKey = 'Data.SecurityType';

        export function getLookup(): Q.Lookup<SecurityTypeRow> {
            return Q.getLookup<SecurityTypeRow>('Data.SecurityType');
        }
        export const deletePermission = 'DataAdmin:SecurityType';
        export const insertPermission = 'DataAdmin:SecurityType';
        export const readPermission = 'Read:SecurityType';
        export const updatePermission = 'DataAdmin:SecurityType';

        export declare const enum Fields {
            SecurityTypeCode = "SecurityTypeCode",
            Name = "Name",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            DefaultSortOrder = "DefaultSortOrder"
        }
    }
}
